(function() { module.exports = this["vendor"]; }());


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 6
// module chunks = 0